<template>
  <div
    class="header-box"
    vkshop-event-scope="header"
  >
    <div
      class="header-web"
      v-if="!isStudentCenterApp"
    >
      <div class="header-info clearfixnew container">
        <div class="vipkid fl">
          <a href="/">
            <img
              src="@/assets/images/header/vipkidlogo.png"
              alt="VIPKID在线青少儿英语"
            >
          </a>
        </div>
        <ul class="banner clearfixnew fl">
          <li
            v-if="$route.name && $route.name !== 'createPackorder'"
            class="toggle course-series active"
          >
            <a
              href="/shop/index"
              vkshop-event-name="courseSeries"
              vkshop-event-type="click"
            >
              <span>课程包系列</span>
              <i></i>
            </a>
          </li>
          <li
            v-if="$route.name && $route.name === 'createPackorder'"
            class="confirm-packorder"
          ><span>确认订单</span></li>
          <template v-if="$route.name && $route.name === 'orderList'">
            <li
              v-for="(o, i) in headerList"
              :key="i"
              class="toggle course-series"
              @click="goToParent(o)"
            >
              <span>{{o.name}}</span>
              <div
                class="icon-text"
                v-if="o.iconText"
              >{{o.iconText}}</div>
            </li>
          </template>
        </ul>

        <div class="login-apply fr">
          <div v-if="!isLogin">
            <div
              class="login-in"
              @click="loginIn"
            >
              登录
            </div>
            <div
              class="apply"
              @click="apply"
            >
              注册
            </div>
          </div>
          <div v-else>
            <div class="parent-info">
              <span
                class="my-home"
                @click="toMyHome"
                vkshop-event-name="myHome"
                vkshop-event-type="click"
              >{{userName}}</span>
              <span
                class="login-out"
                @click="signOut"
              >退出</span>
            </div>
            <div
              class="my-order"
              @click="toMyOrder"
              vkshop-event-name="myOrder"
              vkshop-event-type="click"
            >
              我的订单
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="header-app"
      v-else
    >
      <div
        class="back-icon icon-module"
        @click="goBack"
      >
        <img src="@/assets/images/header/back.svg" />
      </div>
      <div
        class="home-icon icon-module"
        @click="goStudentHome"
      >
        <img src="@/assets/images/header/studentCenter.svg" />
        <span>去首页</span>
      </div>

    </div>
  </div>
</template>
<script>
import { loginIn, apply } from '@/util/auth'
export default {
  name: 'pcHeader',
  data() {
    return {
      userName: null,
      parentId: null,
      isLogin: false,
      headerList: [{
        name: '个人主页',
        url: '/parent/home',
      }, {
        name: '公开课',
        url: '/parent/openclass',
        iconText: '热'
      }, {
        name: '学习中心',
        href: 'https://lc.vipkid.com.cn',
      }, {
        name: '数字图书馆',
        href: 'https://lc.vipkid.com.cn/dgl/digitalLibrary',
        iconText: 'new'
      }],
      isStudentCenterApp: window.navigator.userAgent.includes('VIPKID') && window.navigator.userAgent.includes('PCStudent') // 用来判断是否在学习中心app
    }
  },
  created() {
    this.parentId = this.$cookies.get('parentId')
    this.isLogin = this.parentId !== null
    // 判断是否登录，登录后获取家长信息
    if (this.isLogin) {
      this.axios({
        method: 'get',
        url: '/mall/api/userCenter/parent/getParentInfo',
        params: {
          parentId: this.parentId
        }
      })
        .then(response => {
          if (response.data && response.data.code == 200) {
            this.userName = response.data.data.name
          }
        })
        .catch(() => {
          // 获取家长信息错误后清除鉴权
          const redirectUri = encodeURIComponent(
            location.origin + '/shop/error/500?msg=' + '该页面丢失了'
          )
          location.href =
            window.$config.signOutUrl + '?redirect_uri=' + redirectUri
        })
    }
  },
  methods: {
    loginIn() {
      loginIn()
    },
    apply() {
      apply()
    },
    signOut() {
      const redirectUri = encodeURIComponent(location.origin + `/shop/index`)
      location.href = window.$config.signOutUrl + '?redirect_uri=' + redirectUri
    },
    toMyOrder() {
      this.$router.push({
        path: '/order/list'
      })
      // location.href = `/parent/packorders`
    },
    toMyHome() {
      location.href = `/parent/home`
    },
    // 保留家长端之前的头部跳转
    goToParent(o) {
      const href = o.url ? window.location.origin + o.url : o.href
      window.open(href)
    },
    goStudentHome() {
      window.location.href = window.location.origin.includes('qa') ? 'http://stage-lc.vipkid-qa.com.cn/newmajor' : 'https://lc.vipkid.com.cn/newmajor'
    },
    goBack() {
      // window.history.back()
      window.history.go(-1)
    }
  }
}
</script>

<style lang="less" >
.header-box {
  position: relative;
  width: 100%;
  .header-web {
    height: 90px;
    background: #fff;
    box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.02),
      0 15px 40px 0 rgba(0, 0, 0, 0.02);
    .header-info {
      position: relative;
      .vipkid {
        width: 114px;
        height: 90px;
        line-height: 90px;
        margin: 0 30px;
        text-align: center;
        img {
          width: 100%;
          display: inline-block;
          vertical-align: middle;
        }
      }
      ul.banner {
        height: 90px;
        line-height: 90px;
        .toggle {
          position: relative;
          float: left;
          margin: 0 15px;
          font-weight: 600;
          cursor: pointer;
          .icon-text {
            position: absolute;
            display: inline-block;
            right: 0;
            top: 50%;
            transform: translateX(110%);
            margin-top: -16px;
            font-size: 12px;
            font-weight: 100;
            background-color: #fece0f;
            color: #804c01;
            height: 14px;
            line-height: 14px;
            width: auto;
            padding: 0 2px;
            border-radius: 2px;
            text-align: center;
          }
          &.active,
          & > a:hover {
            font-weight: 600;
          }
          &.active {
            & > a {
              i {
                display: block;
              }
            }
          }
          & > a {
            display: inline-block;
            width: 100%;
            height: 100%;
            color: #333;
            text-decoration: none;
            span {
              font-size: 16px;
            }
            i {
              display: none;
              position: absolute;
              width: 26px;
              height: 3px;
              left: 50%;
              bottom: 24px;
              border-radius: 2px;
              margin-left: -13px;
              background: #ffaf00;
            }
          }
        }
      }
      .login-apply {
        line-height: 90px;
        margin-right: 30px;
        .login-in {
          width: 75px;
          height: 40px;
          line-height: 40px;
          font-size: 16px;
          color: #f85415;
          background: none;
          text-align: center;
          border-radius: 20px;
          border: 1px solid #f85415;
          cursor: pointer;
          display: inline-block;
          &:hover {
            background: #e64507;
            box-shadow: 0 0 10px 0 rgba(255, 103, 26, 0.3),
              0 5px 10px 0 rgba(255, 103, 26, 0.6);
            color: #fff;
          }
        }
        .apply {
          margin-left: 10px;
          width: 75px;
          height: 40px;
          line-height: 40px;
          font-size: 16px;
          color: #fff;
          background: #f85415;
          text-align: center;
          border-radius: 20px;
          border: none;
          cursor: pointer;
          display: inline-block;
          box-shadow: 0 0 10px 0 rgba(255, 103, 26, 0.2),
            0 5px 10px 0 rgba(255, 103, 26, 0.4);
          &:hover {
            background: #e64507;
            box-shadow: 0 0 10px 0 rgba(255, 103, 26, 0.3),
              0 5px 10px 0 rgba(255, 103, 26, 0.6);
          }
        }
        .parent-info {
          font-size: 16px;
          display: inline-block;
          .login-out {
            cursor: pointer;
            font-size: 16px;
            &:hover {
              font-weight: 600;
            }
          }
        }
        .my-home {
          cursor: pointer;
          font-size: 16px;
          margin-right: 8px;
          &:hover {
            font-weight: 600;
          }
        }
        .my-order {
          display: inline-block;
          font-size: 16px;
          margin-left: 24px;
          cursor: pointer;
          &:hover {
            font-weight: 600;
          }
        }
      }
      .confirm-packorder {
        line-height: 90px;
        font-size: 16px;
        font-weight: 600;
        color: #333;
        display: inline-block;
      }
    }
  }
  .header-app {
    .icon-module {
      position: fixed;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.4);
      height: 80px;
      width: 80px;
      z-index: 9999;
      &.back-icon {
        border-radius: 0px 0px 15px 15px;
        left: 32px;
        top: 0;
      }
      &.home-icon {
        border-radius: 0px 40px 40px 0px;
        left: 0;
        top: 35%;
        img,
        span {
          margin-left: -12px;
        }
        span {
          display: inline-block;
          font-size: 14px;
          line-height: 20px;
          color: #fff;
        }
      }
    }
  }
}
</style>